import { render, staticRenderFns } from "./DialogGuardarFiltros.vue?vue&type=template&id=7042c0e6&"
import script from "./DialogGuardarFiltros.vue?vue&type=script&lang=js&"
export * from "./DialogGuardarFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports